import { Component, Prop, h, Host, State, Element, Listen, Watch } from '@stencil/core';

@Component({
  tag: 'pn-bonus-progressbar',
  styleUrl: 'pn-bonus-progressbar.scss',
})
export class PnBonusProgressbar {
  @Element() hostElement: HTMLElement;

  @Prop() icon: string = null;
  @Prop() heading: string = '';
  @Prop({ reflect: true }) sumtext: string = null;
  @Prop({ reflect: true }) theme: string = 'blue';
  @Prop() bonuspercentage: string = '0%';
  @Prop({ reflect: true }) currency: string = 'kr';
  @Prop({ reflect: true, mutable: true }) value: number = 0;
  @Prop({ reflect: true, mutable: true }) min: number = 0;
  @Prop({ reflect: true, mutable: true }) max: number = 0;

  @State() valuepercentage: number = 0;
  @State() progresspercentage: number = 0;
  @State() levelValues: number[] = [];
  @State() currentLevelAdjustedValue: number = 0;

  componentWillLoad() {
    this.setInitialValues();
    this.setValuePercentage();
  }

  setInitialValues() {
    const levelElements = Array.from(this.hostElement.querySelectorAll('pn-bonus-progressbar-level:not([current])'));
    this.currentLevelAdjustedValue = this.value;
    this.levelValues = levelElements.map(elm => {
      return parseInt(elm.getAttribute('value'), 10);
    });
    if (!this.max) {
      if (this.levelValues && this.levelValues.length > 0) {
        const newMax = this.levelValues.slice(-1)[0] as number;
        let modifier = 1.05;
        if (this.value > newMax) {
          modifier = 1.2;
        }
        this.max = Math.floor(newMax * modifier); // This sets the max value which all levels are relative to
      }
    }

    // if (!this.min) {
    //   const suggestedMin = Math.floor(this.value * 0.9);
    //   if (suggestedMin > 0) {
    //     this.min = suggestedMin;
    //   }
    // }

    if (this.value > this.max) {
      this.currentLevelAdjustedValue = 100;
    }
  }

  @Watch('currentLevelAdjustedValue')
  @Watch('value')
  @Watch('min')
  @Watch('max')
  setValuePercentage() {
    this.valuepercentage = (this.value / this.max) * 100;
    this.progresspercentage = ((this.value - this.min) / (this.max - this.min)) * 100;
    if (this.progresspercentage < 0) {
      if (this.levelValues && this.levelValues.length && this.levelValues[0] < this.value) {
        this.min = Math.floor(this.levelValues[0] * 0.95);
      } else {
        this.min = Math.floor(this.value * 0.95);
      }
    }

    if (this.progresspercentage > 100) {
      this.progresspercentage = 100;
      const newMax = this.levelValues.slice(-1)[0] as number;
      let modifier = 1.05;
      if (this.value > newMax) {
        modifier = 1.2;
      }
      this.max = Math.floor(newMax * modifier); // This sets the max value which all levels are relative to
      // this.max = Math.floor(newMax * 1.20);
    }
  }

  iconColor() {
    switch (this.theme) {
      case 'red':
        return 'coral700';
      case 'blue':
      default:
        return 'blue700';
    }
  }

  render() {
    return (
      <Host>
        <div class="bonusprogressbar-top">
          {this.icon ? (
            <div class="bonusprogressbar-top-icon">
              <pn-icon icon={this.icon} small="false" color={this.iconColor()} />
            </div>
          ) : (
            {}
          )}
          <div class="bonusprogressbar-top-heading">
            <h4 class="bonusprogressbar-top-headline">
              {this.heading} <strong class="bonusprogressbar-top-percentage">{this.bonuspercentage}</strong>
            </h4>
            {this.sumtext ? <div class="bonusprogressbar-sumtext">{this.sumtext}</div> : null}
          </div>
        </div>

        <div class="bonusprogressbar-wrapper">
          <progress class="bonusprogressbar-progress" value={this.progresspercentage} max="100"></progress>
          {/* <pn-bonus-progressbar-level current={true} value={this.value} visualpercentage={this.currentLevelAdjustedValue} bonuspercentage={this.bonuspercentage}></pn-bonus-progressbar-level> */}
          {/* <div class="bonusprogressbar-currentlevel" style={ {'left':`%`} }></div> */}
          <slot />
        </div>
      </Host>
    );
  }
}
